import BaseSystemApi from 'api/BaseSystemApi';

export default class CoreSystemApi<Resource = unknown> extends BaseSystemApi<Resource> {
  protected origin = process.env.REACT_APP_CORE_API_URL;
}
